module.exports = __webpack_public_path__ + "img/close__overlay.f7a14f2e.svg";